// extracted by mini-css-extract-plugin
module.exports = {"button":"TextInput_button__3hGw7","input":"TextInput_input__2Oz2l","label":"TextInput_label__2-1Hf","wrapper":"TextInput_wrapper__1rL3D"};